import script from "./customer-service2.vue?vue&type=script&setup=true&lang=js"
export * from "./customer-service2.vue?vue&type=script&setup=true&lang=js"

import "./customer-service2.vue?vue&type=style&index=0&id=19652153&lang=scss&scoped=true"

import exportComponent from "/mnt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19652153"]])

export default __exports__